/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_Concreting, ListCommandResult_Concreting } from "@graphql/helpers/types.graphql";
import { CommandResult, ListCommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TClientType,
  TConcreteMixerType,
  TConcreteRecipeType,
  TConcretingType,
  TConstructionType,
  TContractConcreteRecipeType,
  TContractType,
  TDriverType,
  TJoin,
  TNonEmptyArray,
  TTravelType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TConcretingType
  | TJoin<"contract", TContractType>
  | TJoin<"contract.construction", TConstructionType>
  | TJoin<"contract.construction.client", TClientType>
  | TJoin<"contractConcreteRecipe", TContractConcreteRecipeType>
  | TJoin<"contractConcreteRecipe.concreteRecipe", TConcreteRecipeType>
  | TJoin<"travels", TTravelType>
  | TJoin<"travels.concreteMixer", TConcreteMixerType>
  | TJoin<"travels.driver", TDriverType>;

type TConcretingByIdFunctions = {
  getByID: CommandResult_Concreting;
};
export type TConcretingByIdQueries = {
  concreting: TConcretingByIdFunctions;
};

export const concretingById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query concretingById($id: Guid!) {
    concreting {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Concreting")}
`;

type TConcretingAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_Concreting;
};
export type TConcretingAllWithPaginationQueries = {
  concreting: TConcretingAllWithPaginationFunctions;
};
export const concretingAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concretingAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    concreting {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Concreting")}
`;

type TConcretingAllWithSortedPaginationFunctions = {
  getAllWithSortedPagination: ListCommandResult_Concreting;
};
export type TConcretingAllWithSortedPaginationQueries = {
  concreting: TConcretingAllWithSortedPaginationFunctions;
};
export const concretingAllWithSortedPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concretingAllWithSortedPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]) {
    concreting {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Concreting")}
`;
